define([
	"dojo/_base/declare",
	"Quality/CopyTestRun"
], function(declare,CopyTestRun) {

	return declare(CopyTestRun, {
		bSampleContext: true
	});
});